import { Dispatch, memo, SetStateAction, useCallback, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import {
  CurrencySymbolE,
  PurchaseStepE,
} from "components/Pages/Purchases_new/models/enums";
import ThanksPaymentMethodSection from "../PaymentMethodSection/ThanksPaymentMethodSection";

import styles from "../thanksActionModals.module.scss";
import Icon from "components/Elements/Icon/Icon";

interface PurchaseModalI {
  currentCurrency: CurrencySymbolE;
  sliderValue: number;
  setActiveModal: Dispatch<
    SetStateAction<
      "amount-for-thanks" | "complete-purchase" | "thanks-form-modal"
    >
  >;
  firstModalId: "amount-for-thanks" | "complete-purchase" | "thanks-form-modal";
  activeModal: string;
  isFailed:boolean,
  setIsFailed: Dispatch<SetStateAction<boolean>>;
}

const PurchaseModal = memo(
  ({
    currentCurrency,
    sliderValue,
    setActiveModal,
    firstModalId,
    activeModal,isFailed,setIsFailed
  }: PurchaseModalI) => {
    const { getTextByKey, getDirection } = useContent();

    const [step, setStep] = useState(PurchaseStepE.FIRST_PURCHASE_METHOD_STEP);

    const handleBack = useCallback(() => {
      if (activeModal === "complete-purchase") {
        setActiveModal(firstModalId);
      }
    }, [activeModal, firstModalId, setActiveModal]);

    return (
      <>
        <div
          className={`${styles.modal} ${styles.purchaseModal} ${
            step === PurchaseStepE.THIRD_PAYMENT_STEP ? styles.thirdStep : ""
          }`}
        >
          {step === PurchaseStepE.THIRD_PAYMENT_STEP && (
            <button
              onClick={() => setStep(PurchaseStepE.SECOND_INVOICE_DETAILS_STEP)}
              className={`${styles.arrowWrap}  ${
                getDirection() === "rtl"
                  ? styles.arrRightPos
                  : styles.arrLeftPos
              }`}
            >
              {getDirection() === "rtl" ? (
                <Icon name="arrow-right" white iconClass={styles.arrow} />
              ) : (
                <Icon name="arrow-left" white iconClass={styles.arrow} />
              )}
            </button>
          )}
          <div className={styles.purchaseTextContentWrap}>
            <div className={styles.purchaseTextWrap}>
              <h5>{getTextByKey("complete-your-purchase")}</h5>
              <p className={styles.description}>
                {getTextByKey("purchase-support-message")}
              </p>
              <p className={styles.noteDescription}>
                <span>{getTextByKey("please-note")} </span>
                {getTextByKey("payment-non-refund-message")}
              </p>
            </div>
            <p className={styles.purchaseCurrency}>
              {currentCurrency}
              {sliderValue}
            </p>
          </div>
        </div>
        <div className={styles.paymentContentWrap}>
          <ThanksPaymentMethodSection
            handleBack={handleBack}
            transactionAmount={sliderValue}
            step={step}
            setStep={setStep}
            isFailed={isFailed}
            setIsFailed={setIsFailed}
          />
        </div>
      </>
    );
  }
);

export default PurchaseModal;
